import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-accounts')({
  beforeLoad: () => getTitleContextSlice('All Accounts'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
